import React, { useEffect, useState } from 'react';

import api from '../../api/axios';

const specializationColor = (s) => {
  if (s === 'CARD_ISSUE')          return 'bg-blue-100 text-blue-700';
  if (s === 'APPROVAL_ISSUE')      return 'bg-purple-100 text-purple-700';
  if (s === 'REIMBURSEMENT_ISSUE') return 'bg-green-100 text-green-700';
  if (s === 'TECHNICAL_ISSUE')     return 'bg-amber-100 text-amber-700';
  if (s === 'ONBOARDING_ISSUE')    return 'bg-teal-100 text-teal-700';
  if (s === 'REPORT_ISSUE')        return 'bg-indigo-100 text-indigo-700';
  if (s === 'OTHER')               return 'bg-gray-100 text-gray-600';
  return 'bg-gray-100 text-gray-600';
};

const ByAgent = () => {
  const [stats, setStats] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/api/admin/tickets/by-agent'),
      api.get('/api/admin/agents'),
    ]).then(([statsRes, agentsRes]) => {
      setStats(statsRes.data);
      setAgents(agentsRes.data);
    }).finally(() => setLoading(false));
  }, []);

  const rows = stats.map(row => {
    const agent = agents.find(a => a.agentId === row.agentId);
    return { ...row, specializations: agent?.specializations || [] };
  });

  return (
    <div className="min-h-screen bg-gray-50">
      
      <div className="w-full px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Agent Workload</h1>
          <p className="text-gray-500 text-sm">Support agent ticket breakdown and specializations</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          {loading ? (
            <div className="text-center py-8 text-gray-400">Loading...</div>
          ) : (
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  {['Agent ID', 'Agent Name', 'Specializations', 'Total', 'Open', 'Resolved'].map(h => (
                    <th key={h} className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {rows.map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm text-gray-500">{row.agentId}</td>
                    <td className="px-6 py-4 text-sm font-medium text-gray-800">{row.agentName}</td>
                    <td className="px-6 py-4">
                      <div className="flex flex-wrap gap-1">
                        {row.specializations.length > 0 ? (
                          row.specializations.map(s => (
                            <span key={s} className={`text-xs font-medium px-2 py-0.5 rounded-full ${specializationColor(s)}`}>
                              {s.replace(/_/g, ' ')}
                            </span>
                          ))
                        ) : (
                          <span className="text-xs text-gray-400 italic">None assigned</span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm font-bold text-gray-700">{String(row.total)}</td>
                    <td className="px-6 py-4 text-sm font-semibold text-amber-600">{String(row.open)}</td>
                    <td className="px-6 py-4 text-sm font-semibold text-green-600">{String(row.resolved)}</td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr><td colSpan={6} className="text-center py-8 text-gray-400">No data available</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ByAgent;
